/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useGridApiRef, GridActionsCellItem } from '@mui/x-data-grid-pro';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AskDialog from '../../../components/common/dialog/AskDialog';
import * as employeeApi from '../../../lib/api/employee';
import {
  listCounsel,
  unloadCounsel,
} from '../../../modules/empModule/empResume';
import _ from 'lodash';

import CounselList from '../../../components/employeemng/resume/CounselList';

const CounselListContainer = ({ employee,editFunction }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { counsels, error, loading } = useSelector(
    ({ empModule, loading }) => ({
      counsels: empModule.employeeResume.counsels,
      error: empModule.employeeResume.counselsError,
      loading: loading['employee/LIST_COUNSEL'],
    }),
  );

  useEffect(() => {
    if (employee) {
      dispatch(listCounsel({ id: employee.usrUuid, infoTyp: 'COUNSEL' }));
    }

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadCounsel());
    };
  }, []);

  const apiRef = useGridApiRef();

  
  const [removeId, setRemoveId] = useState(null);


  const onRemove = async () => {
    try {
      const res = await employeeApi.removeResumeByEmp(removeId);
      if (res) {
        apiRef.current.updateRows([{ id: removeId, _action: 'delete' }]);
        enqueueSnackbar('삭제 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setRemoveId(null);
  };

  const deleteCode = useCallback(
    (id) => () => {
      setVisible(true);
      setRemoveId(id);
    },
    [],
  );

  const editCode = useCallback(
    (params) => () => {
      // const data = _.find(counsels,(item)=>item.infoUuid === params.row.infoUuid);
      // console.log(data,'item');
      editFunction(params.row);
    },
    [],
  );

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'infoUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'usrUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'infoTyp',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'attrVal1',
        headerName: '종류',
        minWidth: 100,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'attrVal2',
        headerName: '면담내용',
        minWidth: 100,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'attrVal3',
        headerName: '등록일자',
        minWidth: 100,
        flex: 1,
        type: 'date',
        editable: false,
      },
      {
        field: 'cngNm',
        headerName: '수정자',
        minWidth: 80,
        flex: 0.3,
        type: 'string',
        editable: false,
      },
      {
        field: 'cngDt',
        headerName: '수정일',
        minWidth: 100,
        flex: 0.5,
        type: 'dateTime',
        editable: false,
      },
      {
        field: 'actions',
        type: 'actions',
        width: 80,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            onClick={editCode(params)}
            //showInMenu
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={deleteCode(params.id)}
          />,
        ],
      },
    ],
    [deleteCode, editCode],
  );

  const [visible, setVisible] = useState(false);

  const onCancle = () => {
    setVisible(false);
    setRemoveId(null);
  };

  const onConfirm = () => {
    setVisible(false);
    onRemove();
  };

  return (
    <>
      <CounselList
        apiRef={apiRef}
        columns={columns}
        rows={counsels}
        error={error}
        loading={loading}
      />
      <AskDialog
        visible={visible}
        title="상담내역 삭제"
        description="선택한 상담내역을 삭제하시겠습니까?"
        confirmText="삭제"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </>
  );
};

export default CounselListContainer;
